import React from 'react';
import { Link } from 'react-router-dom';
import NotificationCountdown from 'components/NotificationCountdown';
import AuctionIcon from 'resources/FeatureIcons/Button-Auctions.svg';
import DesktopNotification from '../DesktopNotification';

export default function AuctionEndSoon({ auctionId, endTime, ...rest }) {
  const to = auctionId ? '/auctions/' + auctionId : '/auctions';
  return (
    <DesktopNotification
      className="notification-auction-end-soon"
      title={
        <NotificationCountdown
          text={'Auction ends in '}
          time={endTime}
          onClose={rest.onClose}
          notificationId={rest.notificationId}
        />
      }
      content={
        'An auction is ending in 5 minutes! Tap here to place final bids and see who wins!'
      }
      iconSrc={AuctionIcon}
      footer={
        <Link
          className="btn button-color-green notification-auction-end-soon-button"
          to={to}
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Join Now</span>
        </Link>
      }
      {...rest}
    />
  );
}
